import moment from 'moment';

function BinStatus(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

BinStatus.prototype = Object.assign(BinStatus.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.fileProcessStatus &&
            tableData.fileProcessStatus.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data && data.totalRecordCount) {
            const {
                hasNextPage,
                hasPreviousPage,
                pageNumber,
                pageSize,
                sortingCriteria,
                totalNumberOfPages,
                totalRecordCount,
            } = data;
            return {
                hasNextPage,
                hasPreviousPage,
                pageNumber,
                pageSize,
                sortingCriteria,
                totalNumberOfPages,
                totalNumberOfRecords: totalRecordCount || 0,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            failRecordCount,
            fileName,
            requestId,
            requestStaus,
            successRecordCount,
            totalRecordCount,
            uplodedDate,
        } = row;
        return {
            failRecordCount,
            fileName: fileName || '-',
            requestId: requestId || '-',
            requestStaus: this.formatStatus(requestStaus) || '-',
            successRecordCount,
            totalRecordCount,
            uplodedDate: this.formatData(uplodedDate) || '-',
        };
    },
    formatData(date) {
        return moment(date).format('DD/MM/YYYY');
    },
    formatStatus(status) {
        if (status === 'COMPLETED') {
            return 'Completed';
        }
        if (status === 'IN_PROCESS') {
            return 'Inprocess';
        }
        if (status === 'INITIATED') {
            return 'Initiated';
        }
        return '-';
    },
});

export default BinStatus;
